// Declare types
/// <reference types="jquery.cookie" />

import { Module } from 'lib/vendor/terrific/Module';
import { Hook } from 'lib/vendor/terrific/Sandbox';
import SDXModalDialog from 'lib/generic/SDXModalDialog';

/**
 * Tc.Module.PexMustReadModal
 */
export default class PexMustReadModal extends Module {

	private $html! : JQuery;
	private title! : string;
	private ajaxUrl! : string;

	/**
	 * Hook function to do all of your module stuff.
	 *
	 * @method on
	 * @param  {Hook} callback Callback function
	 * @return void
	 */
	public on(callback : Hook) {
		this.log.debug('starting');

		this.$html = this.$ctx.find('.sdx-container');
		const showModal = this.$html.find('ul').length > 0;
		const $button = this.$html.find('sdx-button');
		this.ajaxUrl = $button.data('ajaxUrl');
		$button.on('click', this.buttonClick.bind(this));

		this.title = this.$ctx.data('title');
		this.log.debug('Should show modal: ', showModal);

		if (showModal) {
			SDXModalDialog.show({
				class: 'text-align-left',
				html: this.$html,
				title: this.title,
			});

		}
		callback();
	}

	private buttonClick() {
		this.log('click event');
		const checked = (this.$html.find('sdx-input-item')[0] as HTMLInputElement).checked;
		if (checked) {
			this.log('call servlet', this.ajaxUrl);
			$.post({
				data: {},
				url: this.ajaxUrl,
			}).then(() => {
				SDXModalDialog.close();
			});
		} else {
			SDXModalDialog.close();
		}
	}

}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/pex/Tc.Module.PexMustReadModal.ts